import * as icons from '../atoms/icons'

export const IconComponent = (icon) => {
	const component = Object.keys(icons)?.find((iconName) => iconName === icon) || null
	// eslint-disable-next-line import/namespace
	return component ? icons[component] : null
}
